/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
import * as configCat from 'configcat-js';

export class ConfigCatWrapper {
    static createClient = configCat.createClient;
    static createConsoleLogger = configCat.createConsoleLogger;
}
